import axios from "axios";
import { getToken } from "../utils/auth";

// 创建axios实例
const api = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // 未授权，可能是token过期
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// 登录
export const login = (username, password) => {
  return api.post("/login", { username, password });
};

// 获取所有设备
export const getDevices = () => {
  return api.get("/devices");
};

// 获取单个设备
export const getDevice = (id) => {
  return api.get(`/device?id=${id}`);
};
